import React from 'react';
import { connect } from 'react-redux';
import FlipMove from 'react-flip-move';
import classNames from 'classnames';
import propTypes from 'prop-types';

// @tcc
import { getMessage } from 'util/locale';

// constants
import { scenario } from 'constants/types';

// selectors
import {
  getScenarios,
  showScenariosList
} from 'advanced/scenarios/selectors';

// components
import ScenarioForDensityTool from './ScenarioForDensityTool';

const baseString = 'vra-scenarios-list';

let ScenariosListContainer = ({
  areScenariosToShow,
  scenarios,
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
  });

  scenarios = scenarios.map((scenario) => {
    const { scenarioUuid } = scenario;

    return (// the wrapper div is needed by FlipMove.
      <div key={`scenario-${scenarioUuid}`}>
        <ScenarioForDensityTool scenario={scenario} />
      </div>
    );
  });

  return areScenariosToShow ? (
    <section className={classString}>
      <header className={`${baseString}__scenarios`}>{getMessage('label-text__scenarios')}</header>
      <ul className={`${baseString}__scenarios`}>
        <FlipMove>
          {scenarios}
        </FlipMove>
      </ul>
    </section>
  ) : null;
};
ScenariosListContainer.propTypes = {
  areScenariosToShow: propTypes.bool.isRequired,
  scenarios: propTypes.arrayOf(scenario).isRequired,
};

ScenariosListContainer = connect(
  (state) => {
    return {
      scenarios: getScenarios(state),
      areScenariosToShow: showScenariosList(state),
    };
  }
)(ScenariosListContainer);
export default ScenariosListContainer;
